import { useEffect, useState } from "react";
import Favourite from "./Favourite";
import { getFavourites } from "../../../services/meals";
import { useCookies } from "react-cookie";

export default function Favourites({
  cart,
  setCart,
  showMessage,
  setShowMessage,
}) {
  const [cookie] = useCookies(["access_token"]);
  const [favourites, setFavourites] = useState([]);

  useEffect(() => {
    getFavourites(cookie.access_token).then((res) => setFavourites(res.data));
  }, []);
  return (
    <>
      <div className="favourites">
        {favourites?.map((favourite) => {
          return (
            <Favourite
              favourite={favourite}
              cart={cart}
              setCart={setCart}
              showMessage={showMessage}
              setShowMessage={setShowMessage}
            ></Favourite>
          );
        })}
      </div>
    </>
  );
}
